import { tipoVolume } from './services';
import { Form, Select } from 'antd';
import Swal from 'sweetalert2';
import { useEffect, useState } from 'react';
import mask from 'utils/mask';

const SelectTipoVolume: React.FC = () => {
  const { Option } = Select;
  const [volumes, setVolumes] = useState([]);

  useEffect(() => {
    try {
      tipoVolume.getVolumes().then((res) => {
        setVolumes(res.data.volumes);
      });
    } catch (error) {
      Swal.fire({
        title: 'Não foi possivel carregar os tipos de volumes, por favor tente novamente!',
        html: '',
        icon: 'warning',
        showConfirmButton: false,
        timer: 1500,
      });
    }
  }, []);

  return (
    <Form.Item
      label=""
      name="tipoVolume"
      rules={[{ required: true, message: 'Por favor, informe o tipo do volume' }]}
    >
      <Select
        placeholder="Selecione o tipo do volume"
        style={{ width: '100%' }}
        filterOption={(inputValue, element) =>
          element?.children.toString().toLowerCase().includes(inputValue.toLowerCase())
        }
        showSearch
      >
        {volumes?.map((item: any) => (
          <Option value={item.cod}>{mask('camelCase', item.descricao)}</Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default SelectTipoVolume;
